import { Check } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle, scrollToId } from "./shared";
import { useSite } from "../../context/SiteContext";

export default function Pricing() {
  const { content } = useSite();
  const p = content?.pricing;
  if (!p || p.visible === false) return null;

  return (
    <section id="investimento" className="py-20 lg:py-28 bg-warmwhite" data-testid="pricing-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <Eyebrow>Investimento</Eyebrow>
          <SectionTitle>{p.title}</SectionTitle>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 bg-sand border border-gold/25 rounded-3xl p-8 sm:p-12 gold-frame" data-testid="pricing-card">
            <p className="font-serif text-2xl sm:text-3xl text-ink" data-testid="pricing-from">{p.from_text}</p>
            <p className="mt-3 text-lg text-cocoa font-light" data-testid="pricing-range">{p.range_text}</p>
            <p className="mt-2 text-sm text-stone2 italic">{p.fallback_text}</p>
            <div className="mt-7 flex flex-wrap justify-center gap-2">
              {(p.payment || []).map((m) => (
                <span key={m} className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] bg-white border border-gold/30 text-olive px-4 py-2 rounded-full" data-testid={`pricing-payment-${m.toLowerCase()}`}>
                  <Check className="w-3.5 h-3.5 text-gold" /> {m}
                </span>
              ))}
            </div>
            <p className="mt-7 text-xs text-stone2 leading-relaxed max-w-xl mx-auto" data-testid="pricing-disclaimer">
              {p.disclaimer}
            </p>
            <button
              data-testid="pricing-cta-button"
              onClick={() => scrollToId("consulte")}
              className="mt-8 inline-flex items-center gap-2 bg-olive hover:bg-olivedark text-cream font-semibold text-sm tracking-wide px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.03]"
            >
              SOLICITAR PROPOSTA
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
